module.exports = __webpack_public_path__ + "img/diners.e36e2fe6.svg";